import React, { Component } from 'react';
import '../../../styles/variables.css';
import './BackendVacancies.css';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {NotificationContainer} from 'react-notifications';
import {ShowNotification} from '../../../components/HandleNotifications'
import uuid from 'uuid';
import Editor from '../components/Editor';
import {createNew, removeJobs} from '../../../actions/_vacancies_actions';
import CurrencyFormat from 'react-currency-format';

class VacancyEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNew: false,
            edit:{},
            editorRender: false,
            payload: {
                jobSalary: '',
                companyName: this.props.company ? this.props.company.companyName : 'IBM',
                companyAbout: this.props.company ? this.props.company.companyAbout : '',
                companyLogo: this.props.company ? this.props.company.companyLogo : '',
                jobTitle: this.props.job ? this.props.job.jobTitle : '',
                seniority: this.props.job ? this.props.job.seniority : '',
                contract: this.props.job ? this.props.job.seniority : '',
                data: this.props.job ? this.props.job.data : "",
                latlang: this.props.company ? this.props.company.latlang : [],
                locationName: this.props.job ? this.props.job.locationName : '',
                img: this.props.company ? this.props.company.companyLogo : '',
                vacancyOwner: this.props.company ? this.props.company.objectID : '',
                jobID:this.props.job ? this.props.job.jobID : uuid.v4(),
                objectID: this.props.job ? this.props.job.objectID : null,
                isUploading: false,
                placeholder: '', 
                Status: true
            }
        }
        
    }

    componentWillMount(){
        if(this.props.match.params.id === undefined){
            this.setState({isNew: true, editorRender: true});
        }else {
            this.props.jobs.map((job) => {
                if (job.jobID === this.props.match.params.id) {
                    var tempProperty = {...this.state.payload}
                    tempProperty.jobSalary = job.jobSalary;
                    tempProperty.jobTitle = job.jobTitle;
                    tempProperty.Status = job.Status;
                    tempProperty.locationName = job.locationName;
                    tempProperty.jobID = job.jobID;
                    tempProperty.contract = job.contract;
                    tempProperty.seniority = job.seniority;
                    tempProperty.data = job.data
                    this.setState({payload: tempProperty, isNew: false, editorRender: true})
                }
            })
        }
    }

    render(){
        const senorities = ['Practicante y Becario', 'Flexible','Junior', 'Senior', 'Ejecutivo', 'Otro'];
        const employmentType = ['Freelance','Flexible','Temporal','Medio tiempo','Tiempo completo'];

        return(
            <div className="b-container">
                <div className="b-actions edit-margins">
                    <button onClick={this.props.history.goBack} className="button__save">
                        Cancelar
                    </button>
                    <button onClick={this.saveData} className="button__submit__edit">
                        {this.state.isNew ? "Publicar" : "Actualizar"}
                    </button>
                </div>
                <div className="b-edit-container">
                    <div className="b-form-container">
                        <p className="b-form-title">{this.state.isNew ? "Nueva Vacante" : "Editar vacante"}</p>
                        {!this.state.isNew ? <p className="b-form-subtitle">Si editas esta vacante tendrá 
                            que ser verificada antes de su publicación en la plataforma.
                        </p>
                         : null}
                        <div className="b-form-inputContainer">
                            <label htmlFor="VFT" className="b-form-labels">Nombre de la vacante</label>
                            <input className="b-form-inputs" type="text" id="VFT"
                            value={this.state.payload.jobTitle} name="jobTitle" onChange={this.handleTextChange}/>
                        </div>
                        <div className="b-form-inputContainer">
                            <label htmlFor="VFS" className="b-form-labels">Rango de Salario</label>
                            <CurrencyFormat className="b-form-inputs" value={this.state.payload.jobSalary} displayType={'input'}
                             thousandSeparator={true} prefix={'$'} name="jobSalary" onChange={this.handleTextChange}/>
                        </div>
                        <div className="b-form-selects">
                            <div className="b-form-select">
                                <label className="b-form-labels">Seniority</label>
                                <select name="seniority" className="b-form-select-custom"
                                    value={this.state.payload.seniority}
                                    onChange={this.handleTextChange}>
                                        <option value="" key="">Selecciona Uno</option>
                                    {senorities.map((type) => (
                                        <option
                                            value={type}
                                            key={type}>
                                            {type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="b-form-select">
                                <label className="b-form-labels">Contrato</label>
                                <select
                                    name="contract" className="b-form-select-custom"
                                    value={this.state.payload.contract}
                                    onChange={this.handleTextChange} >
                                    <option value="" key="">Selecciona Uno</option>
                                    {employmentType.map((type) => (
                                        <option value={type} key={type}>
                                            {type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="b-form-select">
                                <label htmlFor="VFL" className="b-form-labels">Ubicación</label>
                                <input className="b-form-inputs" id="VFL" name="locationName" onChange={this.handleTextChange}
                                value={this.state.payload.locationName} />
                            </div>
                        </div>
                        <div className="b-form-inputDescription">
                            {this.state.editorRender ? <Editor  upstream={this.state.payload.data}
                            sendData={this.sendData}/> : null}
                        </div>
                    </div>
                    <div className="b-form-preview">

                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }

    sendData = (data) => {
        this.setState(prevState => ({
            payload: {
                ...prevState.payload,
                data: data
            }
        }))
    };

   
    saveData = () =>{
        this.props.createNew(this.state.payload, this.state.isNew)
    }

    handleTextChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        this.setState(prevState => {
            let payload = Object.assign({}, prevState.payload);
            payload[name] = value;       
            return { payload };                           
        });
    };
}
const mapStateToProps = (state) => ({
    company: state.company,
    id: state.auth.uid,
    jobs: state.vacancies
})

const mapDispatchToProps = (dispatch) => ({
    createNew: (payload, isNew) => dispatch(createNew(payload, isNew)),
    updateJobs: (newVals) => dispatch(removeJobs(newVals))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VacancyEdit));